import { render, staticRenderFns } from "./questions-add.vue?vue&type=template&id=e1b0ae50&"
import script from "./questions-add.vue?vue&type=script&lang=js&"
export * from "./questions-add.vue?vue&type=script&lang=js&"
import style0 from "./questions-add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b0ae50')) {
      api.createRecord('e1b0ae50', component.options)
    } else {
      api.reload('e1b0ae50', component.options)
    }
    module.hot.accept("./questions-add.vue?vue&type=template&id=e1b0ae50&", function () {
      api.rerender('e1b0ae50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/medical-manage/health-manage/questions-add.vue"
export default component.exports